import { useMutation } from '@tanstack/react-query';
import { api, apiUrls } from '@/lib/apiClient';
import type { ContactResponse } from '@/types/model.types';

/** Replaces ContactService. */
export function useSendMessage() {
  return useMutation({
    mutationFn: (message: string) =>
      api.put<ContactResponse>(apiUrls.contact, {
        operation: 'sending your message',
        body: { message },
      }),
  });
}
